export default "__VITE_ASSET__CAd7K6eH__"